<template>
  <div class="row reverse-mobile justify-content-center">
    <UserMenu></UserMenu>

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="mb-4 text-inherit">Change Password</h3>

        <p>
          If you need help resetting your password, we can help by sending you a
          link to reset it.
        </p>
        <p>Please complete the following steps:</p>
        <ul>
          <li>
            Select
            <b>Send Me A Password Reset Link</b>
          </li>
          <li>Check your inbox for a password reset email</li>
          <li>
            Click on the URL included inside the email and follow the
            instructions on screen
          </li>
        </ul>
        <div class="alert alert-success" v-if="passwordSent">
          <strong>Success!</strong> We have sent you an email with further
          instructions.
        </div>
        <div class="alert alert-danger" v-if="errorFound">
          <strong>Whoops!</strong> There was a problem processing your request.
        </div>
        <form @submit.prevent="requestPasswordReset">
          <button type="submit" class="btn btn-primary">
            Send Me A Password Reset Link
          </button>
        </form>
      </CommunityCard>

      <Footer />
    </div>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import CommunityCard from "../components/CommunityCard";
import Footer from "../components/Footer";
import UserService from "../services/user.service";

export default {
  name: "MyPasswordChange",
  components: {
    UserMenu,
    CommunityCard,
    Footer,
  },
  data() {
    return {
      user() {
        return this.$store.getters.getUser;
      },
      passwordSent: false,
      errorFound: false,
      loading: false,
    };
  },
  methods: {
    requestPasswordReset: function() {
      UserService.requestPasswordResetLoggedIn()
        .then(() => {
          this.passwordSent = true;
          this.errorFound = false;
        })
        .catch(() => {
          this.errorFound = true;
          this.passwordSent = false;
        });
    },
  },
};
</script>

<style scoped></style>
